export default __webpack_public_path__ + "img/slideshow/building_dashboard/3.png";